import { render, staticRenderFns } from "./ModalGrupoDeAcesso.vue?vue&type=template&id=77b802c6"
import script from "./ModalGrupoDeAcesso.vue?vue&type=script&lang=js"
export * from "./ModalGrupoDeAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports